import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Images/logo.png';
import './header.css';

const Header = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <nav className="navbar navbar-expand-lg bg-white navbar-light shadow sticky-top p-0">

      {/* LOGO */}
      <Link to="/" className="navbar-brand d-flex align-items-center px-4 px-lg-5">
        <img
          src={logo}
          alt="Logo"
          style={{ height: '40px', width: 'auto' }}
        />
      </Link>

      {/* TOGGLE */}
      <button
        className="navbar-toggler me-4"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon" />
      </button>

      {/* MENU */}
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-lg-0">

          <Link
            to="/Catalogue"
            className={props.page === "Catalogue" ? "nav-link active" : "nav-link"}
          >
            Formations
          </Link>

          <Link
            to="/certibase"
            className={props.page === "CertiBase" ? "nav-link active" : "nav-link"}
          >
            CertiBase
          </Link>

          <Link
            to="/consulting"
            className={props.page === "Consulting" ? "nav-link active" : "nav-link"}
          >
            Consulting
          </Link>

          {/* RESSOURCES */}
          <div className="nav-item dropdown">
            <a
              href="/"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              onClick={(e) => e.preventDefault()}
            >
              Ressources
            </a>

            <div className="dropdown-menu">
              <Link to="/ressources/faq" className="dropdown-item">FAQ</Link>
              <Link to="/ressources/processus-certification" className="dropdown-item">
                Processus de Certification
              </Link>
              <Link to="/ressources/financement" className="dropdown-item">
                Financement
              </Link>
            </div>
          </div>

          <Link
            to="/evenements"
            className={props.page === "Evenements" ? "nav-link active" : "nav-link"}
          >
            Evenements
          </Link>

          <Link
            to="/contact"
            className={props.page === "Contact" ? "nav-link active" : "nav-link"}
          >
            Contact
          </Link>

          {/* DOWNLOAD PDF */}
          <div className="nav-item dropdown">
            <a
              href="/"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              onClick={(e) => e.preventDefault()}
            >
              Télécharger
            </a>

            <div className="dropdown-menu">

              {/* ✅ PDF OPEN IN NEW TAB */}
              <a
                className="dropdown-item"
                href="/pdfs/new.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                Programme de  <br />
                formations {currentYear}
              </a>

            </div>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default Header;